<template>
  <div>
    <div v-if="emailSent" class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Informações do E-mail</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item">Assunto: <strong>{{ subject }}</strong></li>
        <li class="list-group-item">Remetente: <strong>{{ remetente }}</strong></li>
        <li class="list-group-item">Enviado em: <strong>{{ dataEnviada }} ás {{horaEnviada}}</strong></li>
        <li class="list-group-item">Destinatário: <strong>{{ destinatario }}</strong></li>
        <li class="list-group-item">Status: <strong>{{ generateStatus }}</strong></li>
      </ul>
    </div>

    <div v-if="smsSent && numeroCelular" class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Informações do SMS</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item">Número Celular: <strong>{{ telefoneFormatado }}</strong></li>
        <li class="list-group-item">Mensagem: <strong>{{ mensagem }}</strong></li>
        <li v-if="statusSMS" class="list-group-item">Status: <strong>{{ statusSMS }}</strong></li>
      </ul>
    </div>

    <div class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Corpo da mensagem</h3>
      </div>
      <div class="panel-body" v-html="content">
      </div>
    </div>

    <div class="panel panel-default" v-if="emailSent">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Detalhes do Processamento do E-mail</h3>
      </div>
      <div class="table-responsive">
        <table class="table table-condensed table-hover table-striped">
          <thead>
            <tr>
              <th>Status</th>
              <th>Ocorrido em</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="dataEnviada">
              <td>Enviado</td>
              <td>{{ dataEnviada }} {{ horaEnviada }}</td>
            </tr>
            <tr v-if="dataEntrega">
              <td>Entregue</td>
              <td>{{ dataEntrega }} {{ horaEntrega }}</td>
            </tr>
            <tr v-if="dataLeitura">
              <td>Lido</td>
              <td>{{ dataLeitura }} {{ horaLeitura }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="panel panel-default" v-if="smsSent && statusSMS">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Detalhes do Processamento do SMS</h3>
      </div>
      <div class="table-responsive">
        <table class="table table-condensed table-hover table-striped">
          <thead>
            <tr>
              <th>Status</th>
              <th>Ocorrido em</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="dataEnvioSMS">
              <td>Enviado/Entregue</td>
              <td>{{ dataEnvioSMS }}</td>
            </tr>
            <tr v-if="dataLeituraSMS">
              <td>Lido</td>
              <td>{{ dataLeituraSMS }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'AppInfoEmailSummary',

  props: {
    subject: {
      type: String,
      required: true
    },
    remetente: {
      type: String,
      required: true
    },
    destinatario: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    dataEnviada: {
      type: String,
      required: true
    },
    horaEnviada: {
      type: String,
      required: true
    },
    dataEntrega: {
      type: String,
      required: true
    },
    horaEntrega: {
      type: String,
      required: true
    },
    dataLeitura: {
      type: String
    },
    horaLeitura: {
      type: String
    },
    idImage: {
      type: String
    },
    dataLeituraUTC: {
      type: String
    },
    emailSent: {
      type: Boolean
    },
    numeroCelular: {
      type: String
    },
    mensagem: {
      type: String
    },
    smsSent: {
      type: Boolean
    },
    dataEnvioSMS: {
      type: String
    },
    dataLeituraSMS: {
      type: String
    },
    statusSMS: {
      type: String
    }
  },

  computed: {
    generateStatus () {
      if (this.dataLeitura) {
        return 'Enviado, Entregue e Lido'
      } else if ((this.dataEnviada && this.dataEntrega) && !this.dataLeitura) {
        return 'Enviado e Entregue'
      } else {
        return 'Enviado'
      }
    },
    telefoneFormatado () {
      if (!this.numeroCelular) {
        return ''
      }
      // Remove todos os caracteres não numéricos
      const apenasNumeros = this.numeroCelular.replace(/\D/g, '')
      // Verifica se tem 11 dígitos (DDD + 9 dígitos)
      if (apenasNumeros.length === 11) {
        // Formato: (xx) xxxxx-xxxx
        return `(${apenasNumeros.substring(0, 2)}) ${apenasNumeros.substring(2, 7)}-${apenasNumeros.substring(7, 11)}`
      }
      // Se não tiver 11 dígitos, retorna o número original
      return this.numeroCelular
    }
  },

  mounted () {
    // Fix - Fazer com this.$el
    const divImage = window.jQuery('#background_cinza')
    window.jQuery(divImage.children()[0]).css('float', 'left')
    if (this.idImage.length > 13) {
      divImage.append(`
        <p style="position: absolute; margin-top: 59px; margin-left: 105px; font-size: 10px; padding-right: 25px;">${this.idImage}</p>
      `)
      return
    }
    divImage.append(`
      <p style="position: absolute; margin-top: 60px; margin-left: 80px;">${this.dataLeituraUTC || ''}</p>
      <p style="position: absolute; margin-top: 72px; margin-left: 79px;">${this.idImage}</p>
    `)
  }
}
</script>
<style scoped>
/* ==========================================================================
   Ajustes mobile dos painéis NATIVOS do resumo — não é o corpo do e-mail
   (que vem via v-html e já é tratado no app.css / zoom do Info.vue).
   --------------------------------------------------------------------------
   Em alguns aparelhos o "font boosting" (auto-inflate) do navegador aumenta
   o texto destes painéis Bootstrap (títulos "Informações do E-mail/SMS",
   "Detalhes do Processamento…" e os itens da lista), deixando-os "com zoom".
   Desligamos o auto-inflate e fixamos tamanhos legíveis e compactos.
   Escopado ao componente: desktop e demais telas do app intocados.
   ========================================================================== */
@media screen and (max-width: 767px) {
  .panel-title {
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
    font-size: 15px !important;
  }

  .list-group-item {
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
    font-size: 13px !important;
    line-height: 1.45;
    /* e-mails e URLs longos não empurram a largura do painel */
    overflow-wrap: break-word;
    word-break: break-word;
  }

  /* Tabelas "Detalhes do Processamento" (E-mail/SMS) */
  .table-responsive .table {
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
  }

  .table-responsive .table th,
  .table-responsive .table td {
    font-size: 12px !important;
    white-space: normal;   /* deixa a data/hora quebrar em vez de gerar scroll */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoEmailSummary.vue